import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const cards = [
  { to: "/admin/news", title: "News", desc: "ข่าวสารและประกาศ" },
  { to: "/admin/services", title: "Activities", desc: "กิจกรรม/บริการ" },
  { to: "/admin/portfolio", title: "Gallery", desc: "ภาพกิจกรรม" },
  { to: "/admin/documents", title: "Documents", desc: "เอกสาร" },
  { to: "/admin/clients", title: "Alliance", desc: "โลโก้พันธมิตร" },
  { to: "/admin/settings", title: "Site Settings", desc: "About / Contact / Hero", settingsOnly: true },
  { to: "/admin/admins", title: "Admins", desc: "จัดการผู้ดูแลระบบ", superOnly: true },
];

export default function Dashboard() {
  const { canEditSettings, isSuperAdmin } = useAuth();

  const visibleCards = cards.filter((c) => {
    if (c.superOnly && !isSuperAdmin) return false;
    if (c.settingsOnly && !canEditSettings) return false;
    return true;
  });

  return (
    <div>
      <h2 className="mb-4">Dashboard</h2>

      <div className="row g-3">
        {visibleCards.map((c) => (
          <div key={c.to} className="col-md-4">
            <Link to={c.to} className="text-decoration-none">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{c.title}</h5>
                  <p className="card-text text-muted">{c.desc}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
